module.exports = __webpack_public_path__ + "fonts/Barlow-Black.ac3b1709.ttf";